import { Keys } from "../enums";

export const preventJqueryEsc = (e: JQuery.Event) => {
    if (e.key === Keys.Escape) {
        // @ts-ignore
        e.epHandled(); // don't close task/project details
        e.preventDefault(); // don't close message board dialog
    }
};
